import { useSalesAgentData } from './sales-agent-data'
import { useSalesAgentActions } from './sales-agent-actions'
import { useMemo } from 'react'

const useSalesAgent = () => {
	const salesAgent = useSalesAgentData()
	const actions = useSalesAgentActions()

	return useMemo(() => [salesAgent, actions], [salesAgent, actions])
}

export default useSalesAgent
